import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Divider
} from '@mui/material';
import { Users, Mail, Settings, MapPin, UserCog, Car, Globe } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

const SettingsSection = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const settingsItems = [
    {
      title: 'Manage Users',
      description: 'Add, edit, or remove users and manage their permissions',
      icon: <Users size={24} />,
      onClick: () => navigate('/manage-users')
    },
    {
      title: 'Email Settings',
      description: 'Configure email notifications and templates',
      icon: <Mail size={24} />,
      onClick: () => navigate('/email-settings')
    },
    {
      title: 'Preferred Branch',
      description: 'Change which branch you actively manage and oversee',
      icon: <MapPin size={24} />,
      onClick: () => navigate('/admin/preferred-branch')
    },
    {
      title: 'Web Portal Allocation',
      description: 'Set the allocator, branch percentages, and GL codes for shared software costs',
      icon: <Globe size={24} />,
      onClick: () => navigate('/admin/web-portal-allocation')
    }
  ];

  // Add Service Ops User Management for Service Ops admins
  if (user?.is_admin && user?.branch === 'Service Ops') {
    settingsItems.push({
      title: 'Service Ops User Management',
      description: 'Manage expense reports for Service Ops users',
      icon: <UserCog size={24} />,
      onClick: () => navigate('/admin/service-ops-users')
    });
  }

  // Driver Register entry for admins (always visible for admins)
  if (user?.is_admin) {
    settingsItems.push({
      title: 'Driver Register',
      description: 'View unit assignments and vehicle metadata',
      icon: <Car size={24} />,
      onClick: () => navigate('/admin/driver-register')
    });
  }

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <Settings size={28} style={{ marginRight: '12px' }} />
        <Typography variant="h5">Settings</Typography>
      </Box>

      <Paper>
        <List>
          {settingsItems.map((item, index) => (
            <React.Fragment key={item.title}>
              <ListItem disablePadding>
                <ListItemButton onClick={item.onClick}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText 
                    primary={item.title}
                    secondary={item.description}
                  />
                </ListItemButton>
              </ListItem>
              {index < settingsItems.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Paper>
    </Box>
  );
};

export default SettingsSection; 